module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_gsshop.3f3eabf228f994f68e9e3ec9310c67de.png";